// ==============================我发布的询盘 API==============================
import { jsonPost } from '@/utils/request'

/**
 * @description  网站现舱大厅我发布的现舱、实盘列表
 *
 * @export
 * @param {*} params
 */
export function getMySpacelookWeb(params) {
    return jsonPost({
        url: `webspacehall/getMySpacelookWeb`,
        params
    })

}

/**
 * @description  根据id删除我发布的现舱或询盘
 *
 * @export
 * @param {*} params
 */
export function byPrimaryKeydelete(params) {
    return jsonPost({
        url: `webspacehall/byPrimaryKeydelete`,
        params
    })

}

/**
 * @description  重新发布我发布的现舱或询盘     ：传id
 *
 * @export
 * @param {*} params
 */
export function reissueShippingSpacehall(params) {
    return jsonPost({
        url: `webspacehall/reissueShippingSpacehall`,
        params
    })

}

/**
 * @description  详情接口
 *
 * @export
 * @param {*} params
 */
export function detailAPI(params) {
    return jsonPost({
        url: `webspacehall/WzSpacehalldetails`,
        params
    })

}